module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "dn-gnavi"
  }, [_c('my-inner', {
    attrs: {
      "device": "pc",
      "dumped": !_vm.$store.getters['config/isManabi']
    }
  }), _vm._v(" "), _c('my-inner', {
    attrs: {
      "device": "sp"
    }
  }), _vm._v(" "), _c('dn-bc-banner', {
    staticClass: "dn-gnavi__bc-banner",
    attrs: {
      "screen": "103",
      "type": "04,05"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c03a8e62","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/ui/components/navigations/Gnavi/Gnavi.vue
// module id = 365
// module chunks = 1